import { FlowStateManager } from '../flow-management/FlowStateManager';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { clickCreateNewAccountSameUser } from '../store/auth/action-creators';
import { Step } from '../views/Step';
export const useAcademyHublessUser = () => {
  const dispatch = useAppDispatch();

  const startSignupForHublessUser = () => {
    dispatch(clickCreateNewAccountSameUser(true));
    dispatch(FlowStateManager.removeSteps(Step.LandingPage, Step.Name, Step.Verification, Step.CodeVerification, Step.Password));
  };

  return {
    startSignupForHublessUser
  };
};